var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaypal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10992",
    "data-name": "Group 10992",
    transform: "translate(-123 -398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8656",
    "data-name": "Rectangle 8656",
    transform: "translate(123 398)",
    fill: "#fff",
    stroke: "rgba(112,112,112,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "paypal-mark-color",
    transform: "translate(128.35 404.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10041",
    "data-name": "Path 10041",
    d: "M21.641,8.529c.049-2.572-2.073-4.546-4.991-4.546H10.615a.591.591,0,0,0-.583.5L7.613,19.593a.48.48,0,0,0,.474.555h3.576l-.559,3.5a.48.48,0,0,0,.474.555H14.49a.564.564,0,0,0,.373-.142.53.53,0,0,0,.146-.357l.855-5.031a.73.73,0,0,1,.2-.41.486.486,0,0,1,.341-.142h1.783a5.752,5.752,0,0,0,5.726-4.856,4.4,4.4,0,0,0-2.272-4.734Z",
    transform: "translate(-0.149 -0.174)",
    fill: "#001c64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10042",
    "data-name": "Path 10042",
    d: "M16.362,19.865l-.891,5.648-.559,3.542a.48.48,0,0,0,.474.555h3.083a.591.591,0,0,0,.583-.5l.812-5.149a.59.59,0,0,1,.583-.5h1.815a5.8,5.8,0,0,0,5.725-4.91,4.5,4.5,0,0,0-2.421-4.734,4.836,4.836,0,0,1-.056.638,5.8,5.8,0,0,1-5.726,4.91h-2.84a.59.59,0,0,0-.583.5Z",
    transform: "translate(-4.075 -5.464)",
    fill: "#0070e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10043",
    "data-name": "Path 10043",
    d: "M11.4,20.048H7.81a.479.479,0,0,1-.474-.555L9.754,4.158a.59.59,0,0,1,.583-.5H16.5a4.734,4.734,0,0,1,4.99,4.7,5.388,5.388,0,0,0-2.514-.6H13.839a.591.591,0,0,0-.583.5L12.288,14.4,11.4,20.048Z",
    fill: "#003087"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.d05dbe223fcd3271dd1c9282b256d762.svg";
export { ForwardRef as ReactComponent };